module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar",
    class: {
      drawerActive: _vm.drawer
    }
  }, [_c('v-toolbar', {
    attrs: {
      "app": "",
      "fixed": "",
      "flat": "",
      "height": "94",
      "color": "white"
    }
  }, [_c('v-container', {
    attrs: {
      "navbar-container": ""
    }
  }, [_c('v-toolbar-items', {
    staticClass: "align-center width100"
  }, [_c('span', {
    staticClass: "toggle-icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 12H23",
      "stroke": "black",
      "stroke-width": "2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1 5H23",
      "stroke": "black",
      "stroke-width": "2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1 19H12",
      "stroke": "black",
      "stroke-width": "2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "ml-0 cursor-pointer"
  }, [_c('img', {
    staticClass: "logo ",
    staticStyle: {
      "width": "142px",
      "height": "auto"
    },
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "link-text-wrapper"
  }, _vm._l((_vm.links), function(link) {
    return _c('v-btn', {
      key: link.text,
      staticClass: "nav_text no-Btn-bg",
      attrs: {
        "to": {
          name: link.route
        }
      }
    }, [_vm._v("\n            " + _vm._s(link.text) + "\n          ")])
  })), _vm._v(" "), _c('v-spacer', {}), _vm._v(" "), (!_vm.isAuthenticated) ? _c('v-btn', {
    staticClass: "login_text",
    attrs: {
      "elevation": "0",
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("\n          Sign in\n        ")]) : _c('v-btn', {
    staticClass: "login_text",
    attrs: {
      "elevation": "0",
      "to": {
        name: 'AlbumIndex'
      }
    }
  }, [_vm._v("\n          Discover\n        ")])], 1)], 1)], 1), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndDown) ? _c('v-navigation-drawer', {
    staticClass: "landing-sidebar",
    attrs: {
      "app": "",
      "fixed": "",
      "dark": "",
      "disable-resize-watcher": true
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "mb-6",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "mobile-logo",
    staticStyle: {
      "width": "142px",
      "height": "auto"
    },
    attrs: {
      "src": "/static/images/nav_logo_white.png"
    }
  })]), _vm._v(" "), _vm._l((_vm.links), function(link) {
    return _c('v-list-tile', {
      key: link.text,
      attrs: {
        "router": "",
        "to": link.route
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(link.text))])], 1)
  })], 2), _vm._v(" "), (!_vm.isAuthenticated) ? _c('v-btn', {
    staticClass: "login_text_mobile d-sm-flex d-none justify-md-center align-md-center",
    attrs: {
      "elevation": "0",
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("\n      Sign in\n    ")]) : _c('v-btn', {
    staticClass: "login_text_mobile d-sm-flex d-none justify-md-center align-md-center",
    attrs: {
      "elevation": "0",
      "to": {
        name: 'AlbumIndex'
      }
    }
  }, [_vm._v("\n      Discover\n    ")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-160f9dc0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/landingPages/Header.vue
// module id = 1622
// module chunks = 180